var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container ql-editor"},[_c('PublicHeader',{attrs:{"totalName":_vm.$t('login').ageentTitle}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.agreement)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }